import type { IResourceConfig } from '@/Core/Contracts/UI/Resource'
import { resourceManager } from '@/Core/Managers/Resource'

/**
 * Отримує конфігурацію ресурсу за його ключем або об'єктом конфігурації
 *
 * @param resource - ключ ресурсу (string) або об'єкт конфігурації (IResourceConfig)
 * @returns конфігурацію ресурсу з ключем або null, якщо ресурс не знайдено
 *
 * @example
 * ```typescript
 * // Отримати ресурс за ключем
 * const productResource = GetResourceTask('products')
 *
 * // Передати об'єкт конфігурації напряму
 * const customResource = GetResourceTask({ key: 'custom', title: 'Custom' })
 * ```
 */
export const GetResourceTask = (resource: string | IResourceConfig): (IResourceConfig & { key: string }) | null => {
    // Якщо передано строку - шукаємо ресурс в менеджері
    if (typeof resource === 'string') {
        const foundResource = resourceManager.get(resource)
        if (!foundResource || !foundResource.key) return null
        return foundResource as IResourceConfig & { key: string }
    }

    // Якщо передано об'єкт - перевіряємо наявність ключа
    if (typeof resource === 'object' && resource !== null) {
        if (resource.key === undefined) {
            console.warn('Resource without key parameter', resource)
            return null
        }

        return resource as IResourceConfig & { key: string }
    }

    return null
}
